// eslint-disable-next-line no-unused-vars
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./style.scss";
import Account from "./Components/Frontend/Account";
import Add_Stripe_card from "./Components/Frontend/Add_Stripe_card";
import Forgotpassword from "./Components/Frontend/Forgotpassword";
import Generated from "./Components/Frontend/Generated";
import History from "./Components/Frontend/History";
import Home from "./Components/Frontend/Home";
import Login_inner from "./Components/Frontend/Login_inner";
import Otp from "./Components/Frontend/Otp";
import Otpverification from "./Components/Frontend/Otpverification";
import Payment from "./Components/Frontend/Payment";
import Payment_confirm from "./Components/Frontend/Payment_confirm";
import PaymentSuccessfull from "./Components/Frontend/PaymentSuccessfull";
import Signin from "./Components/Frontend/signin";
import Signup from "./Components/Frontend/Singup";
import Storypreview from "./Components/Frontend/Storypreview";
import AddCard from "./Components/Frontend/stripecard";
import Subscriptionplan from "./Components/Frontend/Subscriptionplan";
import Updateprofile from "./Components/Frontend/Update_profile";
import User_Tips from "./Components/Frontend/User_Tips";
import Verification from "./Components/Frontend/Verification";
import { AuthProvider } from "./context/AuthContext";
import { SubscriptionProvider } from "./context/SubscriptionContext";
import { ProtectedLayout } from "./Components/routes/ProtectedLayOut";
import { AuthProtectedLayout } from "./Components/routes/authLayOut";
import PrivacyPolicy from "./Components/Frontend/PrivacyPolicy";

export default function App() {
  return (
    <SubscriptionProvider>
      <AuthProvider>
        <BrowserRouter basename="userweb">
          <Routes>
            <Route element={<AuthProtectedLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/signin" element={<Signin />} />
              <Route path="/otp" element={<Otp />} />
              <Route path="/otp-verified" element={<Verification />} />
              <Route path="/forgot-password" element={<Forgotpassword />} />
              <Route path="/otpVerification" element={<Otpverification />} />
            </Route>

            <Route path="/subplans" element={<Subscriptionplan />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/stripe-card" element={<Add_Stripe_card />} />
            <Route path="/stripe" element={<AddCard />} />
            <Route path="/payment-confirm" element={<Payment_confirm />} />
            <Route path="/payment-success" element={<PaymentSuccessfull />} />

            <Route element={<ProtectedLayout />}>
              <Route path="/home" element={<Login_inner />} />
              <Route path="/preview" element={<Storypreview />} />
              <Route path="/generated" element={<Generated />} />
              <Route path="/history" element={<History />} />
              <Route path="/tips" element={<User_Tips />} />
              <Route path="/account" element={<Account />} />
              <Route path="/update-profile" element={<Updateprofile />} />
            </Route>
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="*"
              element={
                <div className="d-flex justify-content-center align-items-center vh-100">
                  <h1>404 - Page Not Found</h1>
                </div>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </SubscriptionProvider>
  );
}
